<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1.66638H3.3336V4.99998H0V1.66638Z" :fill="color" />
    <path d="M0 8.33362H3.3336V11.6672H0V8.33362Z" :fill="color" />
    <path d="M0 15H3.3336V18.3336H0V15Z" :fill="color" />
    <path d="M13.3335 8.33362H6.66626V11.6664H19.9999V8.33362H13.3335Z" :fill="color" />
    <path d="M13.3335 15H6.66626V18.3336H19.9999V15H13.3335Z" :fill="color" />
    <path d="M16.6663 1.66638H6.66626V4.99998H19.9999V1.66638H16.6663Z" :fill="color" />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
}
</script>
